/**
 * Name: ROUTES DATA
 * Author: @Gaurav
 * Date: 15-07-2021
 */
import Login from '../pages/Login';
import CustomerList from '../pages/CustomerList';
import SearchSongs from '../pages/Songs';
import AddSongs from '../pages/AddSong';
import EditPlaylistSecondery from '../pages/PlaylistDetails';
import EditPlaylistAndServer from '../pages/EditPlaylistAndServer';
import NewCustomer from '../pages/NewCustomer';
import CustomerDetails from '../pages/CustomerDetails';
import NewPlaylist from '../pages/NewPlaylist';
import EditPlaylistMain from '../pages/EditPlaylistMain';
import EditCustomerScheduler from '../pages/EditCustomerScheduler';
import EditCustomerPlaylist from '../pages/EditCustomerPlaylist';
import UnlimitedPlaylist from '../pages/UnlimitedPlaylist';
import RadioPlaylist from '../pages/RadioPlaylist';
import ArtistDetails from '../pages/ArtistDetail';
import AllArtists from '../pages/Artist';
import ReviewSong from '../pages/ReviewSong';
import UsersVersionTwo from '../pages/UsersVersionTwo';
import UsersVersionTwoDetail from '../pages/UsersVersionTwoDetail';
import PlaylistDetails from '../pages/PlaylistDetails';
import WithDrawals from '../pages/Withdrawals';
import SongDetails from '../pages/SongDetails';

const isProtected = true;

export const ROUTES_DATA = [
  {
    path: '/',
    component: Login,
    exact: true,
  },
  {
    path: '/customer-list',
    component: CustomerList,
    exact: true,
    isProtected: isProtected,
  },
  {
    path: '/songs/search-songs',
    component: SearchSongs,
    exact: true,
    isProtected: isProtected,
  },
  {
    path: '/songs/add-songs',
    component: AddSongs,
    exact: true,
    isProtected: isProtected,
  },
  {
    path: '/songs/review-songs',
    component: ReviewSong,
    exact: true,
    isProtected: isProtected,
  },
  {
    path: '/songs/:id',
    component: SongDetails,
    exact: true,
    isProtected: isProtected,
  },
  {
    path: '/unlimited-playlist',
    component: UnlimitedPlaylist,
    exact: true,
    isProtected: isProtected,
  },
  {
    path: '/radio-playlist',
    component: RadioPlaylist,
    exact: true,
    isProtected: isProtected,
  },
  {
    path: '/unlimited-playlist/:playlistId',
    component: PlaylistDetails,
    exact: true,
    isProtected: isProtected,
  },
  {
    path: '/radio-playlist/:playlistId',
    component: PlaylistDetails,
    exact: true,
    isProtected: isProtected,
  },
  {
    path: '/edit-playlist-secondery',
    component: EditPlaylistSecondery,
    exact: true,
    isProtected: isProtected,
  },
  {
    path: '/unlimited-new-playlist',
    component: NewPlaylist,
    exact: true,
    isProtected: isProtected,
  },
  {
    path: '/radio-new-playlist',
    component: NewPlaylist,
    exact: true,
    isProtected: isProtected,
  },
  {
    path: '/unlimited-playlist/:playlistId/add-songs',
    component: EditPlaylistAndServer,
    exact: true,
    isProtected: isProtected,
  },
  {
    path: '/radio-playlist/:playlistId/add-songs',
    component: EditPlaylistAndServer,
    exact: true,
    isProtected: isProtected,
  },
  {
    path: '/new-customer',
    component: NewCustomer,
    exact: true,
    isProtected: isProtected,
  },
  {
    path: '/update-customer',
    component: NewCustomer,
    exact: true,
    isProtected: isProtected,
  },
  {
    path: '/customer-details',
    component: CustomerDetails,
    exact: true,
    isProtected: isProtected,
  },
  {
    path: '/edit-playlist-main',
    component: EditPlaylistMain,
    exact: true,
    isProtected: isProtected,
  },
  {
    path: '/edit-customer-scheduler',
    component: EditCustomerScheduler,
    exact: true,
    isProtected: isProtected,
  },
  {
    path: '/edit-customer-playlists',
    component: EditCustomerPlaylist,
    exact: true,
    isProtected: isProtected,
  },
  {
    path: '/artists',
    component: AllArtists,
    exact: true,
    isProtected: isProtected,
  },
  {
    path: '/artists/',
    component: AllArtists,
    exact: true,
    isProtected: isProtected,
  },
  {
    path: '/artists/:artist',
    component: ArtistDetails,
    exact: true,
    isProtected: isProtected,
  },
  {
    path: '/artists/:artist/',
    component: ArtistDetails,
    exact: true,
    isProtected: isProtected,
  },
  {
    path: '/users/2.0-users',
    component: UsersVersionTwo,
    exact: true,
    isProtected: isProtected,
  },
  {
    path: '/users/2.0-users/:user',
    component: UsersVersionTwoDetail,
    exact: true,
    isProtected: isProtected,
  },
  {
    path: '/withdrawals/requests',
    component: WithDrawals,
    exact: true,
    isProtected: isProtected,
  },
];

export const OnlyPublicPathNames = ['/'];

